import React, { createContext, useEffect, useState } from 'react';
import { asyncDispatchEvent, getAccessToken, getAdAccounts, getPages } from 'src/pages/FBTool/functions';
import notify from 'src/utils/notify';
import FbToolContent from 'src/pages/FBTool/FBToolContent';
import myStorage from 'src/utils/my.storage';

const ACCESS_TOKEN_KEY = 'accessToken133';
const ADS_TOKEN_KEY = 'adsToken233';
const PAGE_TOKENS_KEY = 'page_tokens';

export const FBToolContext = createContext({});

function FBTool(props) {
    // myStorage.clear();
    const [accessToken, setAccessToken] = useState(() => {
        return myStorage.get(ACCESS_TOKEN_KEY);
    });
    const [adsTokens, setAdsTokens] = useState({});
    const [pageTokens, setPageTokens] = useState(myStorage.get(PAGE_TOKENS_KEY) ?? {});
    const [pages, setPages] = useState({});
    const [selectedPage, setSelectedPage] = useState(null);
    const [selectedAdAccount, setSelectedAdAccount] = useState(null);
    const [adAccounts, setAdAccounts] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [params, setParams] = useState({
        selectedPage: null,
        selectedAdAccount: null,
        limit: 10,
    });

    useEffect(() => {
        init().then();

    }, []);

    useEffect(() => {
        if (accessToken) {
            initToken().then();
        } else {
            removeInitToken();
        }
    }, [accessToken]);

    async function initToken() {
        console.log('[InitToken]');
        setIsLoading(true);
        await fetchAdAccounts();
        await fetchPages();
        setIsLoading(false);
    }

    function removeInitToken() {
        setPages({});
        setAdAccounts({});
    }

    //
    // useEffect(() => {
    //     if (!params.page_id) {
    //         return;
    //     }
    //
    // }, [params]);


    async function init() {
        const token = await getAccessToken();
        if (!token) {
            notify.error('Error get token, please install extension and login facebook before using this tool');
            return;
        }
        setAccessToken(token);
    }


    async function getAdsTokens(args) {
        const act_id = args?.act_id ?? params?.act_id;
        let id = act_id.replaceAll('act_', '');
        if (adsTokens[id]) return adsTokens[id];
        try {
            const { token } = await asyncDispatchEvent('getAdToken', {
                token: accessToken,
                act_id,
            });
            setAdsTokens({
                ...adsTokens,
                [id]: token,
            });
            return token;
        } catch (e) {
            return false;
        }

    }


    async function getPageToken({ pageId }) {
        const token = accessToken;
        const response = await asyncDispatchEvent('getPageToken', { token, pageId: pageId });
        return response.data;
    }

    async function fetchPages() {
        const token = accessToken;
        const response = await getPages({ token });
        if(response.error){
            notify.error(`Fetch pages error: ${response.error.message}`);
            return;
        }
        const pageInfo = (response.data || []).reduce((acc, page) => {
            acc[page.id] = page;
            return acc;
        }, {});
        setPages(pageInfo);
    }

    async function fetchAdAccounts() {
        const token = accessToken;
        const response = await getAdAccounts({ token });
        console.log('[AdAccounts]', response.data);
        const adAccountInfo = (response.data || []).reduce((acc, adAccount) => {
            acc[adAccount.id] = adAccount;
            return acc;
        }, {});
        setAdAccounts(adAccountInfo);

    }

    async function getUseInfo() {

    }


    const data = {
        accessToken,
        setAccessToken,
        pages,
        setPages,
        selectedPage,
        setSelectedPage,
        selectedAdAccount,
        setSelectedAdAccount,
        adAccounts,
        setAdAccounts,
        params,
        setParams,
        isLoading,
        setIsLoading,
        getAdsTokens,
        getPageToken,


    };

    return (
        <FBToolContext.Provider value={data}>
            <FbToolContent />
        </FBToolContext.Provider>
    );
}

export default FBTool;